import { supabase } from "@/config/supabase";

export const getItems = async ({ table = null } = {}) => {
    try {
        const { data, error } = await supabase
            .from(table)
            .select()

        if (error) return Promise.reject(error);

        return data;

    } catch (err) {

        const error = `Error: ${err.message}`;
        return Promise.reject(error);

    }
};